export default {
  brasao: state => state.brasao
};
